import keyMirror from 'keymirror';

export default keyMirror({
  // Asset service action types
  FETCH_USER_TRADE_FEE: null,
  SET_USER_TRADE_FEE: null,
  SET_CURRENCY_RATE_DATA: null,
  FETCH_CURRENCY_RATE_DATA: null,
  FETCH_USER_TRADE_FEE_ERROR: null,
  FETCH_CURRENCY_RATE_DATA_ERROR: null,
  SET_CUR_USER_ASSETS: null,
  SET_ALL_USER_ASSETS: null,
  SET_USER_ASSETS: null,
  SET_ALL_USER_ASSETS_BTC_VALUES: null,
  FETCH_FAVORITES_DATA: null,
  SET_FAVORITES_DATA: null,
  FETCH_FAVORITES_DATA_ERROR: null,
  HANDLE_FAVORITE_DATA_SUCCESS: null,
  HANDLE_FAVORITE_DATA_FAILED: null,
  FETCH_DRIBBLET_BTC: null,
  HANDLE_DRIBBLET_BNB: null,
  FETCH_DRIBBLET_LOG: null,
  FETCH_WITHDRAW_LIMIT_SUCCESS: null,
  FETCH_USER_ASSETS_BY_COIN_SUCCESS: null,
  APPLY_WITHDRAW_SUCCESS: null,

  // User stream action types
  SET_LISTEN_KEY: null,
  SET_MARGIN_LISTEN_KEY: null,
  WEB_SOCKET_STREAMER: null,

  // Mbxgateway order action types
  FETCH_USER_TRADES_DATA: null,
  SET_USER_TRADES_DATA: null,
  SET_USER_TRADES_DATA_WITH_BEFORE: null,
  FETCH_USER_TRADES_DATA_ERROR: null,
  FETCH_OPEN_ORDERS_DATA: null,
  FETCH_OPEN_ORDERS_ERROR: null,
  SET_OPEN_ORDERS_DATA: null,
  SET_MARGIN_OPEN_ORDERS_DATA: null,
  FETCH_TRADE_ORDERS_DATA: null,
  FETCH_TRADE_ORDERS_ERROR: null,
  SET_TRADE_ORDERS_DATA: null,
  SET_TRADE_ORDERS_DATA_WITH_BEFORE: null,
  PLACE_ORDER_START: null,
  PLACE_ORDER_SUCCESS: null,
  PLACE_ORDER_FAILED: null,
  DELETE_ORDER_START: null,
  DELETE_ORDER_SUCCESS: null,
  DELETE_ORDER_FAILED: null,
  SET_ORDERFORM_PRICE_AMOUNT: null,

  // Account types
  FETCH_USER_INFO: null,
  SET_USER_INFO: null,
  SET_ANTI_CODE: null,
  FETCH_USER_INFO_ERROR: null,
  FETCH_KTC_INFO: null,
  FETCH_KTC_INFO_SUCCESS: null,
  FETCH_KTC_INFO_ERROR: null,
  SET_USER_LOGS: null,
  FETCH_USER_LOGS: null,
  FETCH_USER_LOGS_ERROR: null,
  FETCH_USER_CONFIG: null,
  FETCH_USER_CONFIG_SUCCESS: null,
  FETCH_USER_CONFIG_FAILED: null,
  SET_GOOGLE_AUTH_SECRET_KEY_DATA: null,
  FETCH_COUNTRY_SHORT_NAME_SUCCESS: null,
  FETCH_USER_AGENT_MESSAGE_SUCCESS: null,
  FETCH_USER_ANTI_PHISHING_CODE: null,
  SET_USER_ANTI_PHISHING_CODE: null,
  FETCH_USER_ANTI_PHISHING_CODE_ERROR: null,
  FETCH_TRADE_INFO_SUCCESS: null,
  UPDATA_USER_COMMISSION_STATUS_SUCCESS: null,
  FETCH_USER_TOTAL_COMMISSTION_SUCCESS: null,
  FETCH_USER_DEVICE_LIST_SUCCESS: null,
  FETCH_USER_DEVICE_LOG_SUCCESS: null,
  DELETE_USER_DEVICE_SUCCESS: null,
  UPDATE_USER_PASSWORD: null,
  UPDATA_WITHDRAW_WHITE_STATUS_SUCCESS: null,
  FETCH_ACCOUNT_ACTIVITY_RECORD_SUCCESS: null,
  SET_TRADE_LEVEL_INFO: null,
  FETCH_USER_COMMISSTION_TOTAL: null,
  FETCH_USER_COMMISSTION_DETAIL: null,
  SET_TOP_COMMISSION: null,
  SET_BASE_DETAIL: null,
  SET_CONFIRM_TIPS: null,

  // Fiat payment action types
  FETCH_BANK_INFO: null,
  FETCH_BANK_INFO_SUCCESS: null,
  FETCH_BANK_INFO_ERROR: null,
  SET_USER_MONEY_LOG: null,
  SET_USER_MONEY_LOG_INFINIT: null,
  BIND_XFERS_CONFIRM: null,
  BIND_XFERS_CONFIRM_SUCCESS: null,
  BIND_XFERS_CONFIRM_FAILED: null,
  SEND_XFERS_OPT: null,
  SEND_XFERS_OPT_SUCCESS: null,
  SEND_XFERS_OPT_FAILED: null,
  SET_CHARGE_ADDRESS: null,

  // User device action types
  DELETE_DEVICE_HISTORY_SUCCESS: null,
  DELETE_DEVICE_HISTORY_FAILED: null,
  FETCH_USER_DEVICES_LIST: null,
  SET_USER_DEVICES_LIST: null,
  FETCH_USER_DEVICES_LIST_ERROR: null,
  SET_DEVICE_HISTORY_DATA: null,
  FETCH_USER_DEVICE_HISTORY_ERROR: null,

  // Authcenter types
  USER_STATE_LOGGED_IN: null,
  USER_STATE_LOGGED_OUT: null,

  // Register
  SET_REF_SWITCH_INFO: null,
  SET_REGISTER_OPEN_STATUS: null,
  SET_CHECK_IP_RESULT: null,

  // Asset types
  SET_SYMBOL_BY_ASSET: null,
  FETCH_USER_DIVIDENDS: null,
  FETCH_USER_DIVIDENDS_ERROR: null,
  SET_USER_DIVIDENDS: null,
  FETCH_ASSET_PIC: null,
  FETCH_ASSET_PIC_ERROR: null,
  FETCH_ASSET_WITHDRAW_INFO: null,
  FETCH_ASSET_WITHDRAW_INFO_SUCCESS: null,
  FETCH_ASSET_WITHDRAW_INFO_FAILED: null,
  FETCH_ASSETS: null,
  FETCH_ASSETS_SUCCESS: null,
  FETCH_ASSETS_FAILED: null,
  FETCH_WITHDRAW_ADDRESS_SUCCESS: null,
  FETCH_WITHDRAW_ADDRESS_FAILED: null,

  // Common types
  SET_USER_GAS_RATE: null,
  FETCH_USER_GAS_RATE: null,
  FETCH_USER_GAS_RATE_ERROR: null,

  // Country
  FETCH_COUNTRY_WHITELIST_SUCCESS: null,

  // Simplex types
  GET_SIMPLEX_QUORE: null,
  GET_SIMPLEX_QUORE_SUCCESS: null,
  GET_SIMPLEX_QUORE_ERROR: null,
  GET_KOINAL_QUORE_ERROR: null,
  SEND_PAYMENT_REQUEST: null,
  SEND_PAYMENT_REQUEST_SUCCESS: null,
  SEND_PAYMENT_REQUEST_ERROR: null,
  CHECK_SIMPLEX_STATUS_SUCCESS: null,
  CHECK_SIMPLEX_STATUS_ERROR: null,
  GET_SIMPLEX_CURRENCY_LIST_SUCCESS: null,
  GET_SIMPLEX_CURRENCY_LIST_ERROR: null,
  GET_GATEWAY_CHANNEL_SUCCESS: null,
  GET_GATEWAY_CHANNEL_ERROR: null,

  // Info types
  FETCH_ASSET_INFO_SUCCESS: null,
  FETCH_ASSET_INFO_ERROR: null,

  // Blog types
  SET_BLOG_PAGE_SUCCESS: null,
  GET_BLOG_LIST_SUCCESS: null,
  GET_BLOG_DETAIL_SUCCESS: null,
  GET_BLOG_DETAIL_ERROR: null,

  // distribution
  SET_USER_ASSET_DIVIDEND: null,

  // Margin
  SET_MARGIN_STATUS: null,
  SET_MARGIN_ASSET_MODE_START: null,
  SET_MARGIN_ASSET_MODE_BUY: null,
  SET_MARGIN_ASSET_MODE_SELL: null,
  SET_MARGIN_ASSET_MODE_END: null,
  SET_MARGIN_AUTO_REPAY: null,
  SET_MARGIN_BORROW: null,
  SET_MARGIN_STOPLIMIT_OCO_TAB: null,
  SET_MARGIN_COEFF: null,
  SET_MARGIN_SYMBOLS: null,
  SET_MARGIN_ACCOUNT: null,
  SET_MARGIN_ACCOUNT_MAX_BORROWABLE: null,
  SET_MARGIN_ASSETS: null,
  SET_MARGIN_FORCE_UPDATE: null,
  SET_MARGIN_TRADE_ORDERS_DATA: null,
  SET_MARGIN_TRADE_ORDERS_DATA_WITH_BEFORE: null,
  RESET_TRADE_ORDERS_PAGINATION: null,
  RESET_USER_TRADES_PAGINATION: null,

  // margin status
  SET_IS_MARGIN_PAIR: null,
  SET_MARGIN_MODE_TRUE: null,
  SET_MARGIN_MODE_FALSE: null,

  // promocode
  GET_HAS_TRADE_BTC_SUCCESS: null,
  GET_PROMOCODE_SUCCESS: null,
  GET_PROMOCODE_EVENT_INFO_SUCCESS: null,
  FORM_PROMOCODE_SUCCESS: null,

  // user config
  SET_USER_ASSETS_PUBLIC_STATUS: null,
  HIDE_HEADER_LANG_SELECT: null,

  // webauthn
  SET_WEBAUTHN_START_REGISTER: null,
  SET_WEBAUTHN_CREATE_CREDENTIAL: null,
  SET_WEBAUTHN_FINISH_CREDENTIAL: null,
  SET_WEBAUTHN_START_AUTHENTICATE: null,
  SET_WEBAUTHN_CREATE_AUTHENTICATE: null,
  SET_WEBAUTHN_FINISH_DEREGISTER: null,
  SET_WEBAUTHN_QUERY: null,
  SET_WEBAUTHN_ORIGIN_SUPPORTED: null,
  SET_SECURITY_KEY_STATUS: null,
  UPDATE_SECURITY_KEY_STATUS: null,

  GET_ASSET_MIN_TRADE_INFO: null,
  // set inmail data
  SET_IN_MAIL_DATA: null,
  SET_IN_MAIL_MODULS_DATA: null,
  SET_IN_MAIL_FRESH_DATA: null,
  SET_IN_MAIL_UNREAD_COUNT: null,
  UPDATA_IN_MAIL_READ_STATUS: null,
  ADD_IN_MAIL_DATA: null,
  UPATE_IN_MAIL_DATA_COUNT: null,
  // vote2
  SET_VOTE_PROJECT: null,
  SET_VOTE_LOG: null,
});
